module.exports = __webpack_public_path__ + "img/max-logo-white.e790bfcc.svg";